export type SelectItem = { id: string; title?: string; text: string; genid?: string };
export type SelectExtendedItem = SelectItem | { group: string; genid?: string; classList?: string };
export type SelectType = string[] | Record<string, string> | Map<string, string> | SelectExtendedItem[];

export function itemsToArray(type: SelectType | undefined, genId: () => string): SelectExtendedItem[] {
    let result: SelectExtendedItem[] = [];
    if(!type) {
        return result;
    }
    if(Array.isArray(type)) {
        if(typeof type[0] === 'string') {
            result = type.map((item) => ({ id: item, title: item, text: item, genid: genId() }));
        } else {
            result = (type as SelectExtendedItem[]).map((item) => ({ ...item, genid: item.genid || genId() }));
        }
    } else if(type instanceof Map) {
        result = [...type.entries()].map(([key, value]) => ({ id: key, title: key, text: value, genid: genId() }));
    } else {
        result = Object.entries(type).map(([key, value]) => ({ id: key, title: key, text: value, genid: genId() }));
    }
    return result;
}

export function isGroupHeader(item: SelectExtendedItem): item is { group: string; genid?: string } {
    return 'group' in item && typeof item.group === 'string';
}

export function isOptionItem(item: SelectExtendedItem): item is SelectItem {
    return 'id' in item && 'text' in item;
}

export type CheckboxListValue = Record<string, boolean> | Map<string, boolean>;
